import loadConfig from "./loadConfig";

export default async function loadFeatureCatalog(roleName: string) {
    const [defaultCatalog, roleCatalog] = await Promise.all([
        loadConfig('catalog/default'),
        loadConfig(`catalog/${roleName}`)
    ]);
    const catalog = { ...defaultCatalog, ...roleCatalog };
    return catalog;
}